import * as helios from "@hyperionbt/helios"
//wraps helios.Program
export default class Program {
    #program

    constructor(parameters = {}) {
        // load all the dependencies
        const allDeps = []

        const depSrcs = new Map()

        function addDepSrcs(dep) {
            depSrcs.set(dep.name, dep.src)

            for (let d of dep.dependencies) {
                addDepSrcs(d)
            }
        }

        for (let d of allDeps) {
            addDepSrcs(d)
        }

        this.#program = helios.Program.new(`spending marketplace // primary

struct Datum {
  seller_address: Address
  asset_class: AssetClass
  edition_price: Int
}

// TODO: Enforce protocol fees on-chain.
// Currently it's a "negotiation" at the UI between the platform and users.
// Which is actually fine, as we move into a future of shared on-chain infra,
// And people pay for dApp frontends instead.
func main(datum: Datum, _, ctx: ScriptContext) -> Bool {
  signed_by_seller: Bool = datum.seller_address.credential.switch {
    pk: PubKey => ctx.tx.is_signed_by(pk.hash),
    else => false
  };

  if (signed_by_seller) {
    true
  } else {
    prev_output: TxOutput = ctx.get_current_input().output;

    // Tight restrictions for ease of reasoning.
    // We can have a future version that allows shopping cart.
    marketplace_inputs: []TxInput = ctx.tx.inputs.filter((input: TxInput) -> {
      input.output.address == prev_output.address
    });
    assert(marketplace_inputs.length == 1, "Can only buy one Asset at once");

    marketplace_outputs: []TxOutput = ctx.tx.outputs.filter((output: TxOutput) -> {
      output.address == prev_output.address
    });
    assert(marketplace_outputs.length == 1, "Must produce exactly a Marketplace output");

    // TODO: Disallow withdrawing extra ADA?
    next_output: TxOutput = marketplace_outputs.head;
    next_datum: Datum = next_output.datum.switch {
      i: Inline => Datum::from_data(i.data),
      else => error("Invalid marketplace output: missing inline datum")
    };
    assert(next_datum == datum, "Must persist datum");

    prev_no_editions: Int = prev_output.value.get_safe(datum.asset_class);
    new_no_editions: Int = next_output.value.get_safe(datum.asset_class);

    prev_no_editions <= new_no_editions ||
    ctx.tx.outputs.any((output: TxOutput) -> {
      output.address == datum.seller_address &&
      output.value.get_lovelace() >= (prev_no_editions - new_no_editions) * datum.edition_price
    })
  }
}
`, Array.from(depSrcs.values()))

        if (Object.keys(parameters).length > 0) {
            this.#program.parameters = parameters
        }
    }

    get name() {
        return this.#program.name
    }

    get paramTypes() {
        return this.#program.paramTypes
    }

    get parameters() {
        return this.#program.parameters
    }

    get types() {
        return this.#program.types
    }

    set parameters(params) {
        this.#program.parameters = params
    }

    compile(optimize = false) {
        return this.#program.compile(optimize)
    }

    evalParam(paramName) {
        return this.#program.evalParam(paramName)
    }
}
